
(() => {
 const init = () => {
  document.querySelectorAll('.gvn-catalog__hero .gvn-cta-row a').forEach(link => {
   const path = new URL(link.href).pathname;
   if (path === location.pathname) link.setAttribute('aria-current', 'page');
   else link.removeAttribute('aria-current');
  });
  document.querySelectorAll('[data-gvn-catalog]').forEach(root => {
   if (root.dataset.ready) return;
   root.dataset.ready = 'true';
   const form = root.querySelector('form');
   const grid = root.querySelector('[data-gvn-grid]');
   const cards = Array.from(grid.querySelectorAll('[data-gvn-item]'));
   const params = new URLSearchParams(location.search);
   const filters = ['world','category','gender','size','sort'];
   let series = params.get('series') || '';
   const defaults = {world:root.dataset.world,category:root.dataset.category,gender:root.dataset.gender,size:'all',sort:'default'};
   filters.forEach(k => {const el = form.elements.namedItem(k);const value=k==='world'&&defaults.world!=='all'?defaults.world:params.get(k)||defaults[k];if(Array.from(el.options).some(o=>o.value===value))el.value=value;});
   const update = (writeUrl = true) => {
    let count = 0;
    const value = Object.fromEntries(filters.map(k=>[k,form.elements.namedItem(k).value]));
    const sorted = [...cards].sort((a,b) => {
     if(value.sort==='price_low')return Number(a.dataset.price)-Number(b.dataset.price);
     if(value.sort==='price_high')return Number(b.dataset.price)-Number(a.dataset.price);
     if(value.sort==='alpha')return a.dataset.name.localeCompare(b.dataset.name);
     return Number(a.dataset.order)-Number(b.dataset.order);
    });
    sorted.forEach((card,i)=>{
     const d=card.dataset;
     const show=(value.world==='all'||d.world===value.world)&&(value.category==='all'||d.category===value.category)&&(value.gender==='all'||d.gender.split(' ').includes(value.gender))&&(value.size==='all'||d.sizes.includes('|'+value.size+'|'))&&(!series||d.series===series);
     grid.append(card);card.hidden=!show;card.style.order=i;if(show)count++;
    });
    root.querySelector('[data-gvn-count]').textContent=String(count);
    root.querySelector('[data-gvn-empty]').hidden=count>0;
    if(writeUrl){
     const url=new URL(location.href);
     filters.forEach(k=>{if(value[k]===defaults[k])url.searchParams.delete(k);else url.searchParams.set(k,value[k]);});
     if(!series)url.searchParams.delete('series');
     history.replaceState(null,'',url);
    }
   };
   form.addEventListener('change',()=>update());
   form.addEventListener('submit',e=>e.preventDefault());
   form.addEventListener('reset',e=>{e.preventDefault();series='';filters.forEach(k=>form.elements.namedItem(k).value=defaults[k]);update();});
   update(false);
  });
  document.querySelectorAll('.gvn-desktop-menu .gvn-nav-group').forEach(group=>{
   if(group.dataset.ready)return;group.dataset.ready='true';
   const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
   group.querySelector('summary').addEventListener('click',e=>{if(hover.matches){e.preventDefault();group.open=true;}});
   group.addEventListener('pointerenter',()=>{if(hover.matches)group.open=true;});
   group.addEventListener('pointerleave',()=>{if(hover.matches&&!group.contains(document.activeElement))group.open=false;});
   group.addEventListener('focusin',()=>{group.open=true;});
   group.addEventListener('focusout',e=>{if(!group.contains(e.relatedTarget))group.open=false;});
   group.addEventListener('toggle',()=>{if(group.open)document.querySelectorAll('.gvn-desktop-menu .gvn-nav-group').forEach(other=>{if(other!==group)other.open=false;});});
   group.addEventListener('keydown',e=>{if(e.key==='Escape'){group.open=false;group.querySelector('summary').focus();}});
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();


(() => {
 let lastHeaderScroll = window.scrollY;
 const updateHeader = () => {
  const header = document.getElementById('header-component');
  if (!header) return;
  const previous = header.dataset.gvnScrolled === 'true';
  const scrolled = previous ? window.scrollY > 8 : window.scrollY > 32;
  if (header.dataset.gvnScrolled !== String(scrolled)) header.dataset.gvnScrolled = String(scrolled);
  if (header.getAttribute('sticky') === 'scroll-up' && !header.querySelector('[ref="headerMenu"]')) {
   const current = Math.max(0, window.scrollY);
   const atTop = current <= header.offsetHeight;
   const keepOpen = header.matches(':focus-within') || Boolean(header.querySelector('.gvn-nav-group[open], .gvn-mobile-menu[open]'));
   if (atTop) header.dataset.stickyState = 'inactive';
   else if (keepOpen || current < lastHeaderScroll) header.dataset.stickyState = 'active';
   else if (current > lastHeaderScroll) header.dataset.stickyState = 'idle';
   lastHeaderScroll = current;
  }
 };
 window.addEventListener('scroll', updateHeader, { passive: true });
 window.addEventListener('pageshow', updateHeader);
 document.addEventListener('shopify:section:load', updateHeader);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateHeader);
 else updateHeader();
})();

